import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import type { Icon } from '@frontendlib/common/providers/icons/icons';
import { IconComponent } from '@frontendlib/components/components/icon/icon.component';
import { StitchyActivityService } from '../../services/stitchy-activity.service';
import { AttentionDotComponent } from '../attention-dot/attention-dot.component';

const HEAD_SIZE = { nav: 28, fab: 56 } as const;

@Component({
  selector: 'app-stitchy-launcher',
  standalone: true,
  imports: [IconComponent, AttentionDotComponent],
  templateUrl: './stitchy-launcher.component.html',
  styleUrl: './stitchy-launcher.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StitchyLauncherComponent {
  public readonly variant = input<'nav' | 'fab'>('fab');
  public readonly unseen = input<boolean>(false);
  public readonly clicked = output<void>();

  /** Stitchy's state while the panel is away, as the window bar's pill shows it (SBUX-1112). */
  protected readonly activity = inject(StitchyActivityService).config;

  protected readonly headSize = computed(() => HEAD_SIZE[this.variant()]);

  /** The excited pose bobs and wags; the calm head is the resting state. */
  protected readonly head = computed<Icon>(() => (this.unseen() ? 'stitchy-excited' : 'stitchy-head'));

  /** The pose and the dot are the sighted cue; the name carries the same state to a screen reader. */
  protected readonly label = computed<string>(() => {
    const restore = `Restore Stitchy · ${this.activity().label}`;
    return this.unseen() ? `${restore}, something needs your attention` : restore;
  });
}
